'use strict';
require('./EmailToObjectService.js');

var LIMIT = 20;
function EmailToObjectListCtrl(
  $scope,
  $stateParams,
  $translate,
  $state,
  growl,
  emails
) {
  $scope.emails = emails;
  $scope.page = $stateParams.page|0;
  if ($scope.emails.length === (LIMIT + 1)) {
    $scope.more = true;
    $scope.emails.pop();
  }
  $scope.delete = function(item) {
    item.$delete({
      companyId: $stateParams.companyId,
      emailId: item.id
    }, function() {
      $scope.emails.splice($scope.emails.indexOf(item), 1);
      growl.addSuccessMessage($translate.instant('email-to-object.delete-success'));
    }, function() {
      growl.addErrorMessage($translate.instant('email-to-object.delete-failure'));
    });
  };
}

EmailToObjectListCtrl.resolve = {
  emails: ['EmailToObjectService', '$stateParams', function(EmailToObjectService, $stateParams){
    return EmailToObjectService.query({
      companyId: $stateParams.companyId,
      limit: (LIMIT + 1),
      offset: ($stateParams.page|0) * LIMIT
    }).$promise;
  }]
};

module.exports = EmailToObjectListCtrl;

angular.module('dokiv')
  .controller('EmailToObjectListCtrl', [
    '$scope',
    '$stateParams',
    '$translate',
    '$state',
    'growl',
    'emails',
    EmailToObjectListCtrl]);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/email-to-object/EmailToObjectListCtrl.js
// module id = 343
// module chunks = 0